"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonRpcType = void 0;
var json_rpc_base_types_1 = require("./json-rpc-base-types");
Object.defineProperty(exports, "JsonRpcType", { enumerable: true, get: function () { return json_rpc_base_types_1.BaseJsonRpcType; } });
//# sourceMappingURL=index.js.map